/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    ol: "ol",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Set up WebSemaphore"
    }), "\n", _jsx(_components.p, {
      children: "It should take you minutes to set up and start using WebSemaphore following these steps:"
    }), "\n", _jsxs(_components.ol, {
      start: "0",
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/setup/prerequisites",
          children: "Ensure the prerequisites"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/setup/signup",
          children: "Sign up to WebSemaphore"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/setup/semaphore",
          children: "Create and configure your first semaphore"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/usage",
          children: "Continue to the usage section"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
